import React from "react";
import './css/style.css';
import moment from 'moment';
import Cookies from 'universal-cookie';
import Utils from '../utils/utils';


export default class ScheduleView extends React.Component {

    constructor(){
        super();
        this.meetings = [];
        this.scheduleRef = React.createRef();

        this.start = 0;
        this.state = {
            popupVisible: false,
            x: 0,
            y: 0
        }
    }

    componentDidMount(){
        const cookies = new Cookies();
        this.currentEventStartHour = cookies.get('currentEventStartHour', { path: '/' });
        this.currentEventStartMinutes = cookies.get('currentEventStartMinutes', { path: '/' });
        this.currentEventEndHour = cookies.get('currentEventEndHour', { path: '/' });
        this.currentEventEndMinutes = cookies.get('currentEventEndMinutes', { path: '/' });
        this.brokerFlag = cookies.get('brokerFlag', { path: '/' });

        this.labelsTime = [];
        for (var i = parseInt(this.currentEventStartHour) + 1; i < parseInt(this.currentEventEndHour); i++){
            let label = i+":00";
            let position = (this.currentEventStartMinutes / 60) + (i - parseInt(this.currentEventStartHour) - (this.currentEventStartMinutes > 0 ? 1 : 0));
            this.labelsTime.push({
                label: label,
                position: position
            });
        }

        this.meetings = this.props.meetings;
        this.breaks = this.props.breaks;
        this.date = this.props.date;
        this.type = this.props.type;
        this.subject = this.props.subject;

        let endTimestamp = parseInt(this.currentEventEndHour) * 60 + parseInt(this.currentEventEndMinutes);
        let startTimestamp = parseInt(this.currentEventStartHour) * 60 + parseInt(this.currentEventStartMinutes);

        this.hoursCount = (endTimestamp - startTimestamp) / 60;
        let percentageSlot = 100 / this.hoursCount;
        this.slotSize = percentageSlot / 12;

        this.setState({});
    }


    _onMouseClick(e){

        if (this.props.brokerFlag == "true") return;

        let currentSlot = this.state.currentSlot;
        var hours = Math.trunc(currentSlot / 12) + parseInt(this.currentEventStartHour);
        var minutes = (currentSlot % 12) * 5 + parseInt(this.currentEventStartMinutes);
        if (minutes >= 60){
            hours = hours + 1;
            minutes = minutes - 60;
        }

        let date = moment(parseInt(hours)+":"+parseInt(minutes), "hh:mm");
        let timeSlot = moment(date).format("HH:mm");
        let dateSlot = this.date;

        this.props.onMouseClick(dateSlot, timeSlot);
    }

    _onMouseEnter(e) {
        this.setState({popupVisible: true})
    }

    _onMouseLeave(e) {
        this.setState({popupVisible: false})
    }

    _onMouseMove(e) {
        let boundingBox = this.scheduleRef.current.getBoundingClientRect();
        this.start = boundingBox.left;
        this.top = e.screenY - boundingBox.top - boundingBox.height;
        let width = boundingBox.width;
        let slotWidth = (width / this.hoursCount) / 12;
        let currentSlot = Math.trunc((e.clientX - this.start) / slotWidth);
        this.setState({ popupVisible: true, currentSlot: currentSlot, x: (e.clientX - this.start) / width, mouseX: e.clientX, mouseY: e.clientY});
    }


    render (){

        let currentSlot = this.state.currentSlot;
        let hours = Math.trunc(currentSlot / 12) + parseInt(this.currentEventStartHour);
        let minutes = ((currentSlot % 12) * 5 + parseInt(this.currentEventStartMinutes));
        if (minutes >= 60){
            hours = hours + 1;
            minutes = minutes - 60;
        }

        let date = moment(parseInt(hours)+":"+parseInt(minutes), "hh:mm");
        let timeSlot = moment(date).format("HH:mm");

        return ( 
         <div className="mainContainer">
             {
                 this.labelsTime && this.labelsTime.map((v) => {
                     return <div className="timeLbl" style={{left: String(this.slotSize * 12 * v.position)+'%'}}>|  {v.label}</div>
                 })
             }
            <div ref={this.scheduleRef} className="mainClass" 
                onMouseMove={this._onMouseMove.bind(this)}
                onMouseEnter={this._onMouseEnter.bind(this)}
                onMouseLeave={this._onMouseLeave.bind(this)}
                onClick={this._onMouseClick.bind(this)}
            >
            {
                this.meetings && this.meetings.map((meeting) => {

                    if (meeting.date != this.date) return null;
                    var bContinue = false;
                    if (this.type == 'investor' && Utils.checkInvestor(meeting.investors, this.subject) == true) bContinue = true;
                    if (this.type == "company" && this.subject == meeting.company_id) bContinue = true;
                    if (bContinue == false) return null;

                    let startMeeting = (parseInt(meeting.hour) - parseInt(this.currentEventStartHour)) * 12;
                    startMeeting = startMeeting + (parseInt(meeting.minutes) / 5) - parseInt(this.currentEventStartMinutes) / 5;
                    
                    return <SlotElem start={startMeeting} 
                            duration={parseInt(meeting.slots)} 
                            slotSize={this.slotSize} 
                            brokerFlag={this.brokerFlag}
                            parent={this}
                            subject={this.subject}
                            masterFlag={this.props.masterFlag}
                            type={this.type} 
                            meeting={meeting} />
                })
            }
            {
                this.breaks && this.breaks.map((b) => {

                    if (b.date != this.date) return null;
                    if (b.type != this.type) return null;
                    if (b.subject != this.subject) return null;

                    let startBreak = (parseInt(b.hour) - parseInt(this.currentEventStartHour)) * 12;
                    startBreak = startBreak + (parseInt(b.minutes) / 5) - parseInt(this.currentEventStartMinutes) / 5;
                    
                    return <SlotBreak start={startBreak} 
                            duration={parseInt(b.slots)} 
                            slotSize={this.slotSize} 
                            type={this.type} 
                            break={b} />
                })
            }
            </div>
            <div className="popupSchedule" key={Math.random()}
                style={{display: this.state.popupVisible ? 'block' : 'none', 
                left: this.state.mouseX - this.start, 
                top: this.top}} >
                    {timeSlot}
            </div>
        </div>
        )
    }
}

function SlotBreak(props){

    return (<div className={"breakClass"} style={{
        left: String(props.slotSize * props.start)+'%',
        width: String(props.slotSize * props.duration)+'%'}}>
            <p>{props.break.break_type}</p>
    </div> );
}



function SlotElem(props){

    var meetingWithArray = [];

    var meetingWith = '';
    if (props.type == 'company'){
        let investors = props.meeting.investors;
        investors.map((investor, i) => {
            if (i == investors.length - 1) meetingWith = meetingWith + " and ";
            else meetingWith = meetingWith + ", ";

            var label = [<div><b>{investors[i].company}</b></div>];
            label.push(<div> - {investors[i].name}</div>);

            meetingWithArray.push(<div key={investors[i].investor_id} style={{cursor: 'pointer'}} onClick={(e, ee, eee) => {
                if (props.brokerFlag == "true") return;

                const cookies = new Cookies();
                cookies.set('scheduleType', 'investor', { path: '/' });
                cookies.set('scheduleSubject', investors[i].id, { path: '/' });
                props.parent.props.parent.hideEditWindow();
                if (props.masterFlag == true)
                    window.location.href= '#/app/schedule';
                else
                    props.parent.props.parent.reload()}} > {label.map(e => e)}</div>);
        });
    }
    else {
        let investors = props.meeting.investors;

        meetingWithArray.push(<div style={{cursor: 'pointer'}} onClick={() => {
            if (props.brokerFlag == "true") return;

            const cookies = new Cookies();
            cookies.set('scheduleType', 'company', { path: '/' });
            cookies.set('scheduleSubject', props.meeting.company_id, { path: '/' });
            props.parent.props.parent.hideEditWindow();
            props.parent.props.parent.reload()}} > <b>{props.meeting.c_name}</b></div>);
        
            investors.map((investor, i) => {

                if (investors[i].id == props.subject) return undefined;
                var label = [<div><b>{investors[i].company}</b></div>];
                label.push(<div> - {investors[i].name}</div>);

                meetingWithArray.push(<div key={investors[i].investor_id} style={{cursor: 'pointer'}} onClick={(e, ee, eee) => {
                    if (props.brokerFlag == "true") return;
                    const cookies = new Cookies();
                    cookies.set('scheduleType', 'investor', { path: '/' });
                    cookies.set('scheduleSubject', investors[i].id, { path: '/' });
                    props.parent.props.parent.hideEditWindow();
                    props.parent.props.parent.reload()}} > {label.map(e => e)}</div>);

                    return undefined;
            });
        }
        
    var companiesList = [];
    props.meeting.investors.map(inv => {
        if (inv.isAnalyst == 0 && companiesList.indexOf(inv.company) == -1)
            companiesList.push(inv.company);
    });

    let strMeetings = "";
    if (companiesList.length == 0) strMeetings += "Analysts Meeting";
    else if (companiesList.length < 2 ) strMeetings = "1 to 1 Meeting";
    else if (companiesList.length <= 4 ) strMeetings = "1 to few Meeting";
    else strMeetings = "Group meeting ";

    let bFewMeeting = companiesList.length > 1;
    let bGroupMeeting = companiesList.length > 4;


    return (<div className={bGroupMeeting ? "slotGroupClass" : bFewMeeting ? "slotFewClass" : "slotClass"} style={{
        left: String(props.slotSize * props.start)+'%',
        width: String(props.slotSize * props.duration)+'%'}}
        >
            <div className="scheduleMeetingContent" >{strMeetings} with: {meetingWithArray.map(m => m)}</div>
    </div>
    );
}

